import * as moment from 'moment';
import { Moment } from 'moment';
import { Amendment } from '@app/domain/model/amendment';
import { Purchase } from '@app/domain/model/purchase';
import { ReportType } from '@app/domain/model/report-type';
import { Seller } from '@app/feature/seller/seller';
import { Vessel } from '@app/domain/model/vessel';
import { History } from '@app/domain/model/history';

export class PurchaseReceiptReport {

  readonly amendments: Amendment[];

  readonly modifiable: boolean;

  readonly id: number;

  readonly notifyFisher: boolean;

  readonly purchases: Purchase[];

  readonly reportDate: Moment;

  readonly receivedDate: Moment;

  readonly reportType: ReportType;

  readonly remarks: string;

  readonly vessel: Vessel;

  readonly seller: Seller;

  readonly history: History[];

  static fromJSON(jsonObject: any): PurchaseReceiptReport {
    const result = Object.assign(Object.create(PurchaseReceiptReport.prototype), jsonObject, {
      amendments: jsonObject.amendments ? (jsonObject.amendments as any[]).map(element => Amendment.fromJSON(element)) : null,
      purchases: jsonObject.purchases ? (jsonObject.purchases as any[]).map(element => Purchase.fromJSON(element)) : null,
      reportDate: jsonObject.reportDate ? moment(jsonObject.reportDate) : null,
      receivedDate: jsonObject.receivedDate ? moment(jsonObject.receivedDate) : null,
      reportType: jsonObject.reportType ? ReportType.fromString(jsonObject.reportType) : null,
      vessel: jsonObject.vessel ? jsonObject.vessel : '',
      seller: jsonObject.seller ? Seller.fromJSON(jsonObject.seller) : null,
      history: jsonObject.history ? (jsonObject.history as any[]).map(element => History.fromJSON(element)) : null
    });

    return result;
  }

}
